module.exports = {"views.headerLayout.header.signOut.text":"Sign Out","views.headerLayout.header.contactUs.text":"Contact Us"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/views/HeaderLayout.json
// module id = 709
// module chunks = 0